import React from 'react';

function formatNote(note) {
  if (note == null) return '—';
  const n = Number(note);
  if (Number.isNaN(n)) return '—';
  return n.toFixed(1).replace('.', ',');
}

export default function ReviewsHeader({ totalGlobal = 0, note, recentCount, fallbackMode }) {
  const subtitleParts = [];
  if (totalGlobal > 0) subtitleParts.push(`${totalGlobal} avis`);
  if (note != null) subtitleParts.push(`${formatNote(note)}/5`);
  if (typeof recentCount === 'number' && recentCount > 0) subtitleParts.push(`+${recentCount} ce mois`);

  return (
    <div style={styles.wrapper}>
      <h1 style={styles.title}>
        <span aria-hidden>⭐</span> Avis Google
      </h1>
      {subtitleParts.length > 0 && (
        <p style={styles.subtitle}>{subtitleParts.join(' · ')}</p>
      )}
      {fallbackMode && (
        <div style={styles.fallback}>
          <span aria-hidden>⚠️</span>
          <span>Statut des réponses indisponible — affichage en mode lecture</span>
        </div>
      )}
    </div>
  );
}

const styles = {
  wrapper: {
    paddingTop: 'env(safe-area-inset-top)',
    background: '#EDEAE3',
    padding: '16px 16px 4px',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  title: {
    margin: 0,
    fontSize: 22,
    fontWeight: 700,
    color: '#1A1A1A',
    letterSpacing: '-0.01em',
  },
  subtitle: {
    margin: 0,
    fontSize: 13,
    color: '#6B6B6B',
  },
  fallback: {
    marginTop: 8,
    background: '#FFF4D6',
    color: '#1A1A1A',
    padding: '8px 12px',
    borderRadius: 12,
    fontSize: 12,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    lineHeight: 1.4,
  },
};
